module.exports = __webpack_public_path__ + "static/media/outlook_icon.663ee2d7.svg";